import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useErrorMessages } from '../../../../models/hooks/appStateHooks';
import { useInitiateSentMessageImportMutation } from '../../../../queries';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps {
	impersonationContext: Api.IImpersonationContext;
	onSuccess: () => void;
}

export function ImportContactsFromSentMessagesForm({ onSuccess, impersonationContext }: IProps) {
	const errorMessages = useErrorMessages();
	const mutation = useInitiateSentMessageImportMutation({
		impersonationContext,
		onError: error => {
			errorMessages.pushApiError(error);
		},
		onSuccess,
	});
	const onSave = () => {
		mutation.mutate();
	};
	return (
		<div className={css(styleSheet.providerForm, styleSheet.importForm)}>
			<p className={css(styleSheet.providerFormHeader)}>Start Contact Import</p>
			<p className={css(styleSheet.importFormBody)}>
				Start an import to create contacts from on sent messages for the current user. Levitate will look back two years
				to create contacts.
			</p>
			<p className={css(styleSheet.importFormBody)}>This is a background process and may take some time to complete.</p>
			<button disabled={mutation.isPending} className={css(baseStyleSheet.ctaButton)} onClick={onSave}>
				{mutation.isPending ? <LoadingSpinner type='tiny' className={css(styleSheet.providerFormBtnSpinner)} /> : null}{' '}
				Submit
			</button>
		</div>
	);
}
